(function(){
"use strict";

/* ---------- NAV SCROLL SHADOW ---------- */
var nav = document.getElementById('siteNav');
if(nav){
  window.addEventListener('scroll', function(){
    nav.classList.toggle('scrolled', window.scrollY > 10);
  });
}

/* ---------- MOBILE MENU ---------- */
var menuBtn = document.getElementById('menuBtn');
var closeMenuBtn = document.getElementById('closeMenuBtn');
var mobileMenu = document.getElementById('mobileMenu');
if(menuBtn && mobileMenu){ menuBtn.addEventListener('click', function(){ mobileMenu.classList.add('open'); }); }
if(closeMenuBtn && mobileMenu){ closeMenuBtn.addEventListener('click', function(){ mobileMenu.classList.remove('open'); }); }

/* ---------- REVEAL ON SCROLL ---------- */
function observeReveals(){
  var els = document.querySelectorAll('.reveal:not(.in-view)');
  if(!('IntersectionObserver' in window)){ els.forEach(function(el){el.classList.add('in-view');}); return; }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if(entry.isIntersecting){ entry.target.classList.add('in-view'); io.unobserve(entry.target); }
    });
  }, {threshold:.15});
  els.forEach(function(el){ io.observe(el); });
}
observeReveals();

/* ---------- ACCORDION ---------- */
function bindAccordion(scope){
  scope.querySelectorAll('.acc-btn').forEach(function(btn){
    btn.addEventListener('click', function(){
      var open = btn.getAttribute('aria-expanded') === 'true';
      var panel = btn.nextElementSibling;
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      panel.style.maxHeight = open ? '0px' : panel.scrollHeight + 'px';
    });
  });
}
document.querySelectorAll('[data-accordion]').forEach(function(scope){ bindAccordion(scope); });

/* ---------- CART DRAWER (Shopify AJAX Cart API) ---------- */
var cartDrawer = document.getElementById('cartDrawer');
var cartOverlay = document.getElementById('cartOverlay');
var cartBtn = document.getElementById('cartBtn');
var closeCartBtn = document.getElementById('closeCartBtn');

function openCart(){ if(cartDrawer){ cartDrawer.classList.add('open'); cartOverlay.classList.add('open'); } }
function closeCart(){ if(cartDrawer){ cartDrawer.classList.remove('open'); cartOverlay.classList.remove('open'); } }
if(cartBtn){ cartBtn.addEventListener('click', function(){ openCart(); refreshCart(); }); }
if(closeCartBtn){ closeCartBtn.addEventListener('click', closeCart); }
if(cartOverlay){ cartOverlay.addEventListener('click', closeCart); }

function money(cents){
  if (window.Shopify && window.Shopify.formatMoney) {
    return window.Shopify.formatMoney(cents, 'MAD {{amount}}');
  }
  return 'MAD ' + (cents / 100).toFixed(2);
}

function refreshCart(){
  fetch('/cart.js').then(function(r){ return r.json(); }).then(renderCart);
}

function renderCart(cart){
  var countEl = document.getElementById('cartCount');
  if(countEl){
    countEl.textContent = cart.item_count;
    countEl.hidden = cart.item_count === 0;
  }
  var itemsEl = document.getElementById('cartItems');
  var footEl = document.getElementById('cartFoot');
  if(!itemsEl || !footEl) return;

  if(cart.item_count === 0){
    itemsEl.innerHTML = '<div class="cart-empty">Your bag is empty.<br><br><a class="btn btn-solid" href="' + (window.themeProductUrl || '/') + '">Shop Now</a></div>';
    footEl.innerHTML = '';
    return;
  }

  itemsEl.innerHTML = cart.items.map(function(item, i){
    return '<div class="co-line-item">'
      + '<img src="' + (item.image || '') + '" alt="">'
      + '<div class="info">' + item.product_title
      + '<div class="p">' + (item.variant_title || '') + ' \u00b7 Qty ' + item.quantity + '</div></div>'
      + '<div class="amt">' + money(item.final_line_price) + '</div>'
      + '<button class="icon-btn" style="min-width:32px;min-height:32px;padding:4px" aria-label="Remove ' + item.product_title + '" data-remove-key="' + item.key + '">'
      + '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>';
  }).join('');

  footEl.innerHTML = '<div class="co-totals"><div class="row total"><span>Total</span><span>' + money(cart.total_price) + '</span></div></div>'
    + '<div class="cod-note">Cash on delivery only \u2014 you\'ll confirm your address and phone number at checkout, then pay the courier when your order arrives.</div>'
    + '<a class="btn btn-solid btn-block" style="margin-top:14px" href="/checkout">Checkout</a>';

  itemsEl.querySelectorAll('[data-remove-key]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var key = btn.getAttribute('data-remove-key');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({id: key, quantity: 0})
      }).then(function(r){ return r.json(); }).then(renderCart);
    });
  });
}
refreshCart();

/* ---------- ADD TO CART (product page) ---------- */
var addForm = document.getElementById('productForm');
if(addForm){
  addForm.addEventListener('submit', function(e){
    e.preventDefault();
    var formData = new FormData(addForm);
    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    }).then(function(r){ return r.json(); }).then(function(){
      refreshCart();
      openCart();
    }).catch(function(){
      alert('Please select a size before adding to your bag.');
    });
  });
}

/* ---------- SIZE / VARIANT SELECTOR ---------- */
document.querySelectorAll('.size-opt').forEach(function(btn){
  btn.addEventListener('click', function(){
    if(btn.hasAttribute('disabled')) return;
    var group = btn.closest('.sizes');
    group.querySelectorAll('.size-opt').forEach(function(b){ b.classList.remove('selected'); });
    btn.classList.add('selected');
    var hiddenInput = document.getElementById('selectedVariantId');
    if(hiddenInput) hiddenInput.value = btn.getAttribute('data-variant-id');
  });
});

/* ---------- QUANTITY STEPPER ---------- */
var qtyMinus = document.getElementById('qtyMinus');
var qtyPlus = document.getElementById('qtyPlus');
var qtyInput = document.getElementById('qtyInput');
if(qtyMinus && qtyInput){ qtyMinus.addEventListener('click', function(){ qtyInput.value = Math.max(1, parseInt(qtyInput.value||'1',10) - 1); }); }
if(qtyPlus && qtyInput){ qtyPlus.addEventListener('click', function(){ qtyInput.value = parseInt(qtyInput.value||'1',10) + 1; }); }

/* ---------- PRODUCT IMAGE CAROUSEL ---------- */
(function initCarousel(){
  var track = document.getElementById('pdCarouselTrack');
  if(!track) return;
  var dots = document.querySelectorAll('#pdDots span');
  var thumbs = document.querySelectorAll('#pdThumbs .pd-thumb');
  var count = track.children.length;
  var idx = 0;

  function goTo(i){
    idx = (i + count) % count;
    track.style.transform = 'translateX(-' + (idx*100) + '%)';
    dots.forEach(function(d,di){ d.classList.toggle('active', di===idx); });
    thumbs.forEach(function(t,ti){ t.classList.toggle('active', ti===idx); });
  }
  var prevBtn = document.getElementById('pdPrev');
  var nextBtn = document.getElementById('pdNext');
  if(prevBtn) prevBtn.addEventListener('click', function(){ goTo(idx-1); });
  if(nextBtn) nextBtn.addEventListener('click', function(){ goTo(idx+1); });
  thumbs.forEach(function(t){ t.addEventListener('click', function(){ goTo(parseInt(t.getAttribute('data-idx'),10)); }); });

  var carousel = document.getElementById('pdCarousel');
  var startX = 0, deltaX = 0, dragging = false;
  carousel.addEventListener('touchstart', function(e){ dragging=true; startX = e.touches[0].clientX; track.style.transition='none'; }, {passive:true});
  carousel.addEventListener('touchmove', function(e){
    if(!dragging) return;
    deltaX = e.touches[0].clientX - startX;
    var pct = (deltaX / carousel.clientWidth) * 100;
    track.style.transform = 'translateX(calc(-' + (idx*100) + '% + ' + pct + '%))';
  }, {passive:true});
  carousel.addEventListener('touchend', function(){
    dragging = false; track.style.transition = '';
    if(Math.abs(deltaX) > carousel.clientWidth*0.15){ goTo(idx + (deltaX<0?1:-1)); } else { goTo(idx); }
    deltaX = 0;
  });
})();

/* ---------- SUPPORT / LIVE CHAT (mock front-end widget) ---------- */
var supportFab = document.getElementById('supportFab');
var chatPanel = document.getElementById('chatPanel');
var chatOverlay = document.getElementById('chatOverlay');
var closeChatBtn = document.getElementById('closeChatBtn');
var chatInput = document.getElementById('chatInput');
var chatSendBtn = document.getElementById('chatSendBtn');
var chatBody = document.getElementById('chatBody');

function openChat(){
  chatPanel.classList.add('open');
  chatOverlay.classList.add('open');
  supportFab.setAttribute('aria-expanded','true');
  chatInput.focus();
}
function closeChat(){
  chatPanel.classList.remove('open');
  chatOverlay.classList.remove('open');
  supportFab.setAttribute('aria-expanded','false');
}
if(supportFab){
  supportFab.addEventListener('click', function(){
    chatPanel.classList.contains('open') ? closeChat() : openChat();
  });
}
if(closeChatBtn) closeChatBtn.addEventListener('click', closeChat);
if(chatOverlay) chatOverlay.addEventListener('click', closeChat);

function sendChatMessage(){
  var text = chatInput.value.trim();
  if(!text) return;
  var userMsg = document.createElement('div');
  userMsg.className = 'chat-msg user';
  userMsg.textContent = text;
  chatBody.appendChild(userMsg);
  chatInput.value = '';
  chatBody.scrollTop = chatBody.scrollHeight;
  setTimeout(function(){
    var botMsg = document.createElement('div');
    botMsg.className = 'chat-msg bot';
    botMsg.textContent = "Thanks for reaching out \u2014 a member of the ARSIL team will follow up shortly.";
    chatBody.appendChild(botMsg);
    chatBody.scrollTop = chatBody.scrollHeight;
  }, 700);
}
if(chatSendBtn) chatSendBtn.addEventListener('click', sendChatMessage);
if(chatInput) chatInput.addEventListener('keydown', function(e){ if(e.key === 'Enter'){ sendChatMessage(); } });

document.querySelectorAll('[data-open-chat]').forEach(function(el){
  el.addEventListener('click', function(e){ e.preventDefault(); openChat(); });
});

})();
